<template>
  <!-- Page Header -->
  <div class="page-header">
    <div class="row align-items-center">
      <div class="col-1 mr-n5">
        <a @click="$router.back()">
          <i class="fa-solid fa-circle-arrow-left fa-2x"></i>
        </a>
      </div>
      <div class="col-auto">
        <h3 class="page-title">{{ title }}</h3>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <!-- <a v-if="baseRoutesBasedOnTitle[path]"  @click="$router.push(baseRoutesBasedOnTitle[path])">{{ path }}</a>
            <a v-else  @click="$router.back()">{{ path }}</a> -->
            {{ path }}
          </li>
          <li class="breadcrumb-item active">{{ text }}</li>
        </ul>
      </div>
      <div class="col-auto float-end ms-auto" v-if="isShiftTimingsRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('shift_timing-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_shift"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isDesignationRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('designation-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_designation"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isDepartmentRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('department-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_department"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <!-- over time -> resignation (part of theme not hcm) -->
      <div class="col-auto float-end ms-auto" v-if="isOvertimeRoute">
        <a
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_overtime"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isLeaveAdminRoute">
        <a
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_termination"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isHolidayRoute">
        <a
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_holiday"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isJobsRoute">
        <a
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_job"
          ><i class="fa-solid fa-plus"></i>{{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isResignationRoute">
        <a
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_resignation"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <!-- over time -> resignation (part of theme not hcm) -->
      <div
        class="col-auto float-end ms-auto"
        v-if="isRecruitmentRequisitionRoute"
      >
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('recruitment_requisition-create') &&
            conditionalRequest == 'show'
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_recruitment_requisition"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('additional_resource_quota-create') &&
            conditionalRequest == 'hide'
          "
          href="javascript:void(0);"
          class="btn add-btn me-2"
          data-bs-toggle="modal"
          data-bs-target="#request_additional_resource"
          ><i class="fa-solid fa-plus"></i> Request for Additional Resource</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isCountryRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('country-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_country"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isStateRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('state-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_state"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isCityRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('city-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_city"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>

      <!-- <div class="col-auto float-end ms-auto" v-if="isShiftAssignRoute">
        <a
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_city"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div> -->
      <div class="col-auto float-end ms-auto" v-if="isTeamsRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('team-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_team"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isBloodGroupRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('blood_group-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_team"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isMaritalStatusRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('marital_status-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_team"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isGenderRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('gender-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_gender"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isReligionRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('religion-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_team"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isNationalityRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('nationality-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_nationality"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isDivisionRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('division-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_division"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isEmploymentStatusRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('employment_status-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_status"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isSectionRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('section-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_section"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isContactRelationRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('contact_relation-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_contact_relation"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isDocumentTypeRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('document_type-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_document_type"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isCampaignRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('campaign-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_campaign"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isLeaveRenewalRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('leave_renewal-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_leave_renewal"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div
        class="col-auto float-end ms-auto"
        v-if="isLeaveApprovalTimelineService"
      >
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('leave_approval_time_line-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_leave_approval_timeline"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div
        class="col-auto float-end ms-auto"
        v-if="isLeaveRequestTimelineService"
      >
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('leave_request_time_line-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_leave_request_timeline"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isGraceTimeRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('grace_time-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_grace_time"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isLateComingRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('late_coming-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_late_coming"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isAttendanceApproversRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('attendance_approval-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_attendance_approval"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isEmploymentLevelRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('employment_level-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_employment_level"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isEmploymentGradeRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('employment_grade-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_employment_grade"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isAssetTypeRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('asset_type-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_asset_type"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isAssetDetailsRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('asset_details-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_asset_detail"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isAssetRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('asset-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_asset_detail"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>

      <div class="col-auto float-end ms-auto" v-if="isInboxHeaderRoute">
        <!-- <div class="col-auto float-end ms-auto" v-if="isAttendanceDevicesRoute"> -->
        <a
          v-if="
            this.userPermissions.length &&
            (this.userPermissions.includes(isInboxHeaderRoute?.permission) ||
              isInboxHeaderRoute?.permission == 'pending')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          :data-bs-target="isInboxHeaderRoute.target"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>

      <div class="col-auto float-end ms-auto" v-if="isChangeRoute">
        <!-- <div class="col-auto float-end ms-auto" v-if="isAttendanceDevicesRoute"> -->
        <router-link
          v-if="
            this.userPermissions.length &&
            (this.userPermissions.includes(isChangeRoute?.permission) ||
              isChangeRoute?.permission == 'pending')
          "
          class="btn add-btn"
          :to="isChangeRoute.target"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</router-link
        >
      </div>

      <div class="col-auto float-end ms-auto" v-if="isDeviceType">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('device_type-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_device_type"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>

      <div class="col-auto float-end ms-auto" v-if="isAttendanceFlagRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('attendance_flag-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_attendance_flag"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>

      <div class="col-auto float-end ms-auto" v-if="isAttendanceHistoryRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('attendance_history-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_attendance_history"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>

      <!-- <div
        class="col-auto float-end ms-auto"
        v-if="isTimeAdjustmentRequestRoute"
      >
        <a
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_time_adjustment_request"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div> -->

      <div class="col-auto float-end ms-auto" v-if="isNCNSRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('NCNS-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_ncns"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
      <div class="col-auto float-end ms-auto" v-if="isSuspensionRoute">
        <a
          v-if="
            this.userPermissions.length &&
            this.userPermissions.includes('suspensions-create')
          "
          href="javascript:void(0);"
          class="btn add-btn"
          data-bs-toggle="modal"
          data-bs-target="#add_suspensions"
          ><i class="fa-solid fa-plus"></i> {{ text1 }}</a
        >
      </div>
    </div>
  </div>
  <!-- /Page Header -->
</template>

<script>
import { baseRoutesBasedOnTitle } from "@/staticData";

// console.log({ baseRoutesBasedOnTitle });

const inboxHederRoutes = [
  {
    route: "/recruitment/requisition-planning",
    target: "#add_recruitment_requisition",
    permission: 'recruitment_requisition-create',
  },
  {
    route: "/recruitment/manage-applicants",
    target: "#add_applicant",
    permission: 'pending',
  },
  {
    route: "/id-card-management/template",
    target: "#id_card_template_create",
    permission: "pending",
  },
  {
    route: "/basic-setup/half-day-policy",
    target: "#add_half_day_policy",
    permission: "half_day_policy-create",
  },
  {
    route: "/basic-setup/type-form",
    target: "#add_type_form",
    permission: "type_form-create",
  },
  {
    route: "/basic-setup/custom-field",
    target: "#add_custom_field",
    permission: "custom_field-create",
  },
  {
    route: "/basic-setup/part-time",
    target: "#add_part_time",
    permission: "pending",
  },
  {
    route: "/basic-setup/degree",
    target: "#add_degree",
    permission: "degree-create",
  },
  {
    route: "/basic-setup/organization",
    target: "#add_organization",
    permission: "organization-create",
  },
  {
    route: "/organization/hr-manual",
    target: "#add_hr_manual",
    permission: "pending",
  },
  {
    route: "/organization/hr-documents",
    target: "#add_hr_documents",
    permission: "pending",
  },
  {
    route: "/basic-setup/bank",
    target: "#add_bank",
    permission: "bank-create",
  },
  {
    route: "/basic-setup/half-day-leave-policy",
    target: "#add_half_day_leave_policy",
    permission: "half_day_leave_policy-create",
  },
  {
    route: "/basic-setup/approval-time",
    target: "#add_approval_time",
    permission: "approval_time-create",
  },

  {
    route: "/basic-setup/leave-type",
    target: "#add_leave_type",
    permission: "leave_type-create",
  },
  // {
  //   route: "/basic-setup/leave-assign",
  //   target: "#add_leave_assign",
  //   permission: "leave_assign-create",
  // },

  {
    route: "/basic-setup/leaves-applicable",
    target: "#add_leave_applicable",
    permission: "leave_applicable-create",
  },
  {
    route: "/basic-setup/leave-approver",
    target: "#add_leave_approver",
    permission: "leave_approver-create",
  },
  {
    route: "/notification-panel/notification-type",
    target: "#add_notification_type",
    permission: "pending",
  },

  {
    route: "/basic-setup/approval-sandwich",
    target: "#add_approval_sandwich",
    permission: "approval_sandwich-create",
  },

  {
    route: "/basic-setup/late-adjustment",
    target: "#add_late_adjustment",
    permission: "late_adjustment_request-create",
  },
  {
    route: "/my-team/project",
    target: "#add_project",
    permission: "project-create",
  },
  {
    route: "/my-team/performance/achievement",
    target: "#add_team_achievement",
    permission: "project-create",
  },

  {
    route: "/my-team/performance/disciplinary-action",
    target: "#add_disciplinary_action",
    permission: "project-create",
  },

  {
    route: "/holiday-management/weekly-holiday",
    target: "#add_weekly_holiday",
    permission: "weekly_holidays-create",
  },
  {
    route: "/letter-management/letter-applicable",
    target: "#add_letter_applicable",
    permission: "letter_applicable-create",
  },
  {
    route: "/letter-management/letter-type",
    target: "#add_letter_type",
    permission: "letter_type-create",
  },
  {
    route: "/letter-management/letter-generation",
    target: "#add_letter_generation",
    permission: "letter_generation-create",
  },

  {
    route: "/letter-management/issue-letter",
    target: "#add_issue_letter",
    permission: "letter_generation-create",
  },
  {
    route: "/holiday-management/gazette-holiday",
    target: "#add_gazette_holiday",
    permission: "gazette_holiday-create",
  },

  {
    route: "/basic-setup/auto-attendance",
    target: "#add_auto_attendance",
    permission: "auto_attendance-create",
  },
  {
    route: "/attendance/devices",
    target: "#add_devices",
    permission: "attendance_device-create",
  },

  {
    route: "/employee/credentials-management",
    target: "#add_credentials_management",
    permission: "employee_credential-create",
  },

  {
    route: "/payroll-management/salary-type",
    target: "#add_salary_type",
    permission: "salary_type-create",
  },
  {
    route: "/payroll-management/generate-payroll",
    target: "#add_generate_payroll",
    permission: "payroll-create",
  },
  {
    route: "/payroll-management/budget-payroll",
    target: "#add_budget_payroll",
    permission: "payroll_budget-create",
  },

  {
    route: "/payroll-management/tax-slab",
    target: "#add_tax_slab",
    permission: "tax_slab-create",
  },
  {
    route: "/payroll-management/ncns-type",
    target: "#add_ncns_type",
    permission: "ncns_type-create",
  },
  {
    route: "/payroll-management/payroll-adjustment-category",
    target: "#add_payroll_adjustment_category",
    permission: "payroll_adjustment_category-create",
  },
  // {
  //   route: "/role-management/roles-and-permissions",
  //   target: "#add_role",
  //   permission: "role_permission-create",
  // },
  // {
  //   route: "/role-management/assign-role",
  //   target: "#assign_new_role",
  //   permission: "role_permission-role-assign",
  // },

  // {
  //   route: "/recruitment/recruitment-requisition",
  //   target: "#add_recruitment_requisition"
  // },
  {
    route: "/basic-setup/duty-type",
    target: "#add_duty_type",
    permission: "employee_duty_type-create",
  },
  {
    route: "/basic-setup/contract-type",
    target: "#add_contract_type",
    permission: "pending",
  },

  {
    route: "/basic-setup/insurance-card",
    target: "#add_insurance_card",
    permission: "pending",
  },

  {
    route: "/basic-setup/employee-project",
    target: "#add_employee_project",
    permission: "pending",
  },
  {
    route: "/basic-setup/break-type",
    target: "#add_break_type",
    permission: "pending",
  },
  {
    route: "/basic-setup/experience",
    target: "#add_experience",
    permission: "recruitment_experience-create",
  },
  {
    route: "/basic-setup/provident-fund",
    target: "#add_provident_fund",
    permission: "provident_fund-create",
  },
  {
    route: "/basic-setup/career-level",
    target: "#add_career_level",
    permission: "recruitment_career_level-create",
  },
  {
    route: "/basic-setup/higher-exactly",
    target: "#add_higher_exactly",
    permission: "recruitment_higher_exactly-create",
  },
  {
    route: "/basic-setup/recruitment-quota",
    target: "#add_recruitment_quota",
    permission: "recruitment_quota-create",
  },
  {
    route: "/recruitment/aptitude-test",
    target: "#add_aptitude_test",
    permission: "aptitude_test-create",
  },

  {
    route: "/performance-management/project-type",
    target: "#add_project_type",
    permission: "pending",
  },

  {
    route: "/performance-management/feedback",
    target: "#add_feedback",
    permission: "pending",
  },
  {
    route: "/performance-management/assign-form",
    target: "#add_assign_form",
    permission: "pending",
  },

  {
    route: "/performance-management/form-frequency",
    target: "#add_form_frequency",
    permission: "pending",
  },

  {
    route: "/basic-setup/interview-type",
    target: "#add_interview_type",
    permission: "pending",
  },

  {
    route: "/basic-setup/email-template",
    target: "#add_email_template",
    permission: "pending",
  },
  {
    route: "/basic-setup/break-time",
    target: "#add_assign_break",
    permission: "pending",
  },
  {
    route: "/basic-setup/shift-time",
    target: "#add_assign_shift",
    permission: "pending",
  },

  {
    route: "/employee/assign-target",
    target: "#add_assign_target",
    permission: "pending",
  },

  {
    route: "/employee/assign-employee-target",
    target: "#add_assign_employee_target",
    permission: "pending",
  },

  {
    route: "/employee/termination",
    target: "#add_termination",
    permission: "employee_termination-create",
  },
  {
    route: "/employee/promotion",
    target: "#add_promotion",
    permission: "pending",
  },

  {
    route: "/employee/document",
    target: "#add_employee_document",
    permission: "pending",
  },
  // {
  //   route: "/asset-and-services/company-services",
  //   target: "#add_service",
  //   permission: "pending",
  // },
  // {
  //   route: "/asset-and-services/service-records",
  //   target: "#add_service_records",
  //   permission: "pending",
  // },
  {
    route: "/basic-setup/inventory-type",
    target: "#add_inventory",
    permission: "pending",
  },
  {
    route: "/basic-setup/service-type",
    target: "#add_service",
    permission: "pending",
  },
  {
    route: "/basic-setup/inventory-details",
    target: "#add_inventory_details",
    permission: "pending",
  },
  // {
  //   route: "/asset-and-services/assign-inventory",
  //   target: "#add_assign_inventory",
  //   permission: "pending",
  // },

  {
    route: "/basic-setup/card",
    target: "#add_card",
    permission: "pending",
  },

  // {
  //   route: "/asset-and-services/assign-card",
  //   target: "#add_assign_card",
  //   permission: "pending",
  // },

  {
    route: "/asset-and-services/card-request",
    target: "#add_card_request",
    permission: "pending",
  },

  // {
  //   route: "/payroll-management/payment-mode",
  //   target: "#add_payment_mode",
  //   permission: "pending",
  // },

  // {
  //   route: "/performance-and-rewards/peer-assessment",
  //   target: "#add_peer_assessment",
  //   permission: "pending",
  // },

  {
    route: "/ai-assisted-recruitment/job-listing",
    target: "#add_recruitment_requisition",
    permission: "pending",
  },
];

const changeRouteOnAdd = [
  {
    route: "/payroll-management/salary",
    target: "/payroll-management/create-salary",
    permission: "salary-create",
  },

  {
    route: "/performance-management/evaluations-form",
    target: "/performance-management/create-evaluation-form",
    permission: "pending",
  },

  {
    route: "/role-management/roles-and-permissions",
    target: "/role-management/add-role",
    permission: "role_permission-create",
  },

  // {
  //   route: "/performance-and-rewards/self-assesment",
  //   target: "/performance-and-rewards/create-self-assessment",
  //   permission: "pending",
  // },
];
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
    conditionalRequest: {
      type: String,
      default: "",
    },

    baseRoute: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userPermissions: [],
      baseRoutesBasedOnTitle,
    };
  },
  computed: {
    isInboxRoute() {
      return this.$route.path === "/inbox";
    },
    isShiftTimingsRoute() {
      return this.$route.path === "/employee/shift-timing";
    },
    isDesignationRoute() {
      return this.$route.path === "/employee/designation";
    },
    isDepartmentRoute() {
      return this.$route.path === "/employee/department";
    },
    isResignationRoute() {
      return this.$route.path === "/resignation";
    },
    isPromotionRoute() {
      return this.$route.path === "/promotion";
    },
    isTrainingTypeRoute() {
      return this.$route.path === "/training-type";
    },
    isTrainerRoute() {
      return this.$route.path === "/trainers";
    },
    isTrainingRoute() {
      return this.$route.path === "/training";
    },
    isGoalRoute() {
      return this.$route.path === "/goal-tracking";
    },
    isPerformanceRoute() {
      return this.$route.path === "/performance-appraisal";
    },
    isPerformanceindicatorRoute() {
      return this.$route.path === "/performance-indicator";
    },
    isGoaltypeRoute() {
      return this.$route.path === "/goal-type";
    },
    isCountryRoute() {
      return this.$route.path === "/basic-setup/country";
    },
    isRecruitmentRequisitionRoute() {
      return this.$route.path === "/recruitment/recruitment-requisition";
    },
    isStateRoute() {
      return this.$route.path === "/basic-setup/state";
    },
    isCityRoute() {
      return this.$route.path === "/basic-setup/city";
    },

    isShiftAssignRoute() {
      return this.$route.path === "/basic-setup/shift-assign";
    },
    isPendingPayrollRoute() {
      return this.$route.path === "/payroll-management/pending-payroll";
    },
    isApprovedPayrollRoute() {
      return this.$route.path === "/payroll-management/approved-payroll";
    },
    isViewAsRoute() {
      return this.$route.path === "/payroll-management/view-as";
    },
    isSalarySlipsRoute() {
      return this.$route.path === "/payroll-management/salary-slips";
    },
    isPayrollAdjustmentRoute() {
      return this.$route.path === "/payroll-management/payroll-adjustment";
    },
    isTeamsRoute() {
      return this.$route.path === "/basic-setup/team";
    },
    isBloodGroupRoute() {
      return this.$route.path === "/basic-setup/blood-group";
    },
    isMaritalStatusRoute() {
      return this.$route.path === "/basic-setup/marital-status";
    },
    isGenderRoute() {
      return this.$route.path === "/basic-setup/gender";
    },
    isReligionRoute() {
      return this.$route.path === "/basic-setup/religion";
    },
    isNationalityRoute() {
      return this.$route.path === "/basic-setup/nationality";
    },
    isDivisionRoute() {
      return this.$route.path === "/basic-setup/division";
    },
    isEmploymentStatusRoute() {
      return this.$route.path === "/basic-setup/employment-status";
    },
    isAssetTypeRoute() {
      return this.$route.path === "/basic-setup/asset-type";
    },
    isAssetDetailsRoute() {
      return this.$route.path === "/basic-setup/asset-details";
    },
    isAssetRoute() {
      return this.$route.path === "/asset";
    },
    isSectionRoute() {
      return this.$route.path === "/basic-setup/section";
    },
    isContactRelationRoute() {
      return this.$route.path === "/basic-setup/contact-relation";
    },
    isDocumentTypeRoute() {
      return this.$route.path === "/basic-setup/document-type";
    },
    isCampaignRoute() {
      return this.$route.path === "/basic-setup/campaign";
    },

    isGraceTimeRoute() {
      return this.$route.path === "/basic-setup/auto-check-out-limit";
    },
    isLateComingRoute() {
      return this.$route.path === "/basic-setup/late-coming";
    },
    isAttendanceApproversRoute() {
      return this.$route.path === "/basic-setup/attendance_approvers";
    },
    isLeaveRenewalRoute() {
      return this.$route.path === "/basic-setup/leave-renewal";
    },
    isLeaveApprovalTimelineService() {
      return this.$route.path === "/basic-setup/leave-approval-timeline";
    },
    isLeaveRequestTimelineService() {
      return this.$route.path === "/basic-setup/leave-request-timeline";
    },
    isEmploymentLevelRoute() {
      return this.$route.path === "/control-panel/employment-level";
    },
    isEmploymentGradeRoute() {
      return this.$route.path === "/control-panel/employment-grade";
    },
    isLeaveRoute() {
      return this.$route.path === "/leave-type";
    },
    isManageApplicantsRoute() {
      return this.$route.path === "/manage-applicants";
    },

    isInboxHeaderRoute() {
      const route = inboxHederRoutes.find(
        (el) => el.route === this.$route.path
      );
      if (route) return route;

      return false;
    },

    isChangeRoute() {
      const route = changeRouteOnAdd.find(
        (el) => el.route === this.$route.path
      );
      if (route) return route;

      return false;
    },

    isAttendanceDevicesRoute() {
      return this.$route.path === "/attendance/devices";
    },

    isAttendanceFlagRoute() {
      return this.$route.path === "/attendance/attendance-flag";
    },

    isAttendanceHistoryRoute() {
      return this.$route.path === "/attendance/attendance-history";
    },
    isTimeAdjustmentRequestRoute() {
      return this.$route.path === "/attendance/time-adjustment-request";
    },
    isNCNSRoute() {
      return this.$route.path === "/attendance/ncns";
    },
    isSuspensionRoute() {
      return this.$route.path === "/attendance/suspensions";
    },
    isDeviceType() {
      return this.$route.path === "/attendance/device-type";
    },
    isHandbookRoute() {
      return this.$route.path === "/organization/handbook";
    },
  },
  created() {
    this.userPermissions =
      this.$store._state?.data?.auth?.user?.permission?.map((el) => el.name) ||
      [];
  },
};
</script>
